import { VideoChaptersMenuChaptersColumn } from './video-chapters-menu-chapters-column'
import { VideoChaptersMenuLanguageColumn } from './video-chapters-menu-language-column'

const { videojs } = global
const Component = videojs.getComponent('Component')

/**
 * Initialize chapters and language settings columns
 * @class
 * @extends Component
 */
// eslint-disable-next-line import/prefer-default-export
export class VideoChaptersMenuContent extends Component {
  /**
   * @param {Player|Object} player
   * @returns {void}
   */
  constructor (player, options) {
    super(player, { ...options, className: 'vjs-chapters-menu-content' })

    // Only add columns once
    if (!this.children().length) {
      this.#addChaptersColumn()
      this.#addLanguageColumn()
    }
  }

  /**
   * @returns {void}
   */
  #addChaptersColumn () {
    const column = new VideoChaptersMenuChaptersColumn(this.player())
    this.addChild(column)
  }

  /**
   * @returns {void}
   */
  #addLanguageColumn () {
    const column = new VideoChaptersMenuLanguageColumn(this.player())
    this.addChild(column)
  }

  /**
   * Override the createEl method to add headers
   * @returns {HTMLElement}
   */
  createEl () {
    const el = super.createEl()
    return el
  }
}
